import React, { useRef } from "react";
import { toast } from "react-toastify";
import LeftArrow from "../../assets/svg/LeftArrow.svg";
import RightArrow from "../../assets/svg/arrow-right-line.svg";
import styles from "./PostWrapper.module.scss";
import { validateMediaFile } from "../../utils/fileValidation";

const SelectedImage = ({ imagesArray, setImagesArray, setCropContShow, setUploadSection, setSelectedImageShow }) => {
	const inputRef = useRef();

	const handelRemoveImage = (indexToRemove) => {
		const updatedArray = imagesArray.filter((_, index) => index !== indexToRemove);
		setImagesArray(updatedArray);
	};

	const handelAddPhotos = (e) => {
		const file = e.target.files;
		if (file && file.length > 0) {
			let tempArray = Array.from(file);
			for (const f of tempArray) {
				const validation = validateMediaFile(f);
				if (!validation.valid) {
					toast.error(validation.error);
					e.target.value = null;
					return;
				}
			}
			setImagesArray((prev) => [...prev, ...tempArray]);
		}

		e.target.value = null;
	};

	const handleDragOver = (e) => {
		e.preventDefault();
	};

	const handelDrop = (e) => {
		e.preventDefault();
		const file = e.dataTransfer.files[0];
		if (file) {
			const validation = validateMediaFile(file);
			if (!validation.valid) {
				toast.error(validation.error);
				return;
			}
			setImagesArray((prev) => [...prev, file]);
		}
	};

	const handelArrowButton = () => {
		if (imagesArray?.length === 0) toast.error("Please Select an Image !");
		else {
			setSelectedImageShow(false);
			// setUploadSection(true);
			setCropContShow(true);
		}
	};

	return (
		<div className={styles.SelectedImageWrapper}>
			<div className={styles.Top}>
				<img src={LeftArrow} alt="Back" className={styles.PopupCloseBtn} onClick={() => setSelectedImageShow(false)} />
				<h1>fameo-X</h1>
				<img src={RightArrow} alt="Next" className={styles.NextArrowBtn} onClick={handelArrowButton} />
			</div>

			<div className={styles.Bottom} onDrop={handelDrop} onDragOver={handleDragOver}>
				<div className={styles.ImageSection}>
					{imagesArray?.map((data, index) => {
						const isVideo = data.type?.startsWith("video");
						return (
							<div key={index} className={styles.ImageWrapper}>
								<div className={styles.remove} onClick={() => handelRemoveImage(index)}>
									X
								</div>
								{isVideo ? (
									<video src={data instanceof Blob ? URL.createObjectURL(data) : data} />
								) : (
									<img src={data instanceof Blob ? URL.createObjectURL(data) : data} alt="" />
								)}
							</div>
						);
					})}
				</div>

				<div className={styles.DropZone}>
					<h1>Drag & Drop your image or video</h1>
					<h4>Or</h4>
					<input type="file" multiple ref={inputRef} style={{ display: "none" }} onChange={handelAddPhotos} accept=".jpg,.jpeg,.png,.webp,.gif,.svg,.mp4,.mov,.webm,.ogg,image/jpeg,image/png,image/webp,image/gif,video/mp4,video/quicktime,video/webm" />
					<button onClick={() => inputRef.current.click()}>Upload from computer</button>
				</div>
			</div>
		</div>
	);
};

export default SelectedImage;


